import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const ConfigRegimenFiscalExteriorTipo = {

    async Get() {  return await methods.Get("ConfigRegimenFiscalExteriorTipo/Get" ); },
    async Post(data) { return await methods.Post("ConfigRegimenFiscalExteriorTipo/Post", data) },
    async Put(qs, data) { return await methods.Put("ConfigRegimenFiscalExteriorTipo/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("ConfigRegimenFiscalExteriorTipo/Delete" + useParamsJson(qs)) }
};

export default ConfigRegimenFiscalExteriorTipo;